import React from "react";
import { Modal } from "@shopify/polaris";

import { ModalTitle } from "@vendor-app/app/AdminRoute/AdminSetupRoute/libs/styles";
import { SUB_MODAL_TITLE } from "@vendor-app/app/AdminRoute/AdminSetupRoute/Tabs/SubscriptionSetup/libs/constants";
import { createSmartrrModal } from "@vendor-app/utils/createModalStore";
import { GettingStartedStoreAccess } from "../../../libs/store";

export const useCreateSubscriptionModalStore = createSmartrrModal();

export const CreateSubscriptionModal = () => {
  const { closeModal, isModalOpen } = useCreateSubscriptionModalStore();
  const { createNewSellingPlanGroup } = GettingStartedStoreAccess.useActions();
  const setup = GettingStartedStoreAccess.useSetup();
  const isLoading = GettingStartedStoreAccess.useLoading("subscriptionProgram");

  if (!setup) {
    return <React.Fragment />;
  }

  return (
    <Modal
      open={isModalOpen}
      onClose={closeModal}
      title={<ModalTitle>{SUB_MODAL_TITLE}</ModalTitle>}
      primaryAction={{
        content: "Confirm",
        loading: isLoading,
        onAction() {
          createNewSellingPlanGroup();
          closeModal();
        },
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: closeModal,
        },
      ]}
    >
      <Modal.Section>
        You&apos;ll be redirected to our <strong>Subscription Programs</strong> tab to create a new program from
        scratch. Once complete, you&apos;ll be prompted to return here to continue with required setup.
      </Modal.Section>
    </Modal>
  );
};
